import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-full items-center justify-center flex flex-col" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center text-primary-400" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-3xl text-primary-400" }, " Agregar Block ", -1)
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_ComponentCard = _resolveComponent("ComponentCard")!
  const _component_ModalBlock = _resolveComponent("ModalBlock")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ComponentCard, {
      class: "w-80 h-[23rem] bg-primary-100 bg-opacity-20 border-primary-100 border-4 flex items-center justify-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true))
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_mdicon, {
              name: "plus-thick",
              size: "100"
            })
          ]),
          _hoisted_3
        ])
      ]),
      _: 1
    }),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ModalBlock, {
            onReload: _ctx.reload,
            visible: _ctx.showModal,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
            communityId: _ctx.communityId
          }, null, 8, ["onReload", "visible", "communityId"])
        ]))
      : _createCommentVNode("", true)
  ]))
}